import Tab from "@mui/material/Tab";
import { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import { Box, styled } from "@mui/system";
import { Avatar, Grid } from "@mui/material";
import muiIcons from "../../../components/icons/mui-icons";
import { H3, H4, H5 } from "../../../components/Typography";
import Containers from "../../../components/Containers";
import EventTable from "../../../components/tables/EventTable";
import { CardContainer } from "../../../components/CardContainer";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import StatementCard from "../../../components/cards/StatementCard";
import { GullButton } from "../../../components/buttons/GullButton";
import StatementTable from "../../../components/tables/StatementTable";
import useCommonContext from "../../../hooks/useCommonContext";
import PaymentFormModal from "../../../components/modals/PaymentFormModal";
import BasicSortedTable from "../../../components/tables/BasicSortedTable";
import PaymentMethods from "../../../components/accordions/PaymentMethods";
import ProfileAccordion from "../../../components/accordions/ProfileAccordion";
import PaymentMethodModal from "../../../components/modals/PaymentMethodModal";

const counterBoxData = [
  {
    name: "Earning",
    count: "5,299",
    Icon: muiIcons.DownArrowIcon,
  },
  {
    name: "Tasks",
    count: 250,
    Icon: muiIcons.UpArrowIcon,
  },
  {
    name: "Hours",
    count: 700,
    Icon: muiIcons.DownArrowIcon,
  },
];

const CounterBox = styled(Box)<{ index: number }>(({ theme, index }) => ({
  margin: ".4rem",
  padding: ".5rem",
  borderRadius: "5px",
  border: `1px dashed ${theme.palette.grey[300]}`,
  "& h4": {
    color: theme.palette.grey[700],
    "& svg": {
      fontSize: 12,
      marginLeft: "5px",
      color:
        index === 1 ? theme.palette.error.main : theme.palette.success.main,
    },
  },
  "& h5": {
    color: theme.palette.grey.main,
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  marginLeft: 0,
  fontSize: "16px",
  padding: "5px 20px",
  borderRadius: "5px",
  fontWeight: 500,
  color: theme.palette.grey[800],
}));

const CardHeader = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const EventTableHeader = styled(CardHeader)(({ theme }) => ({
  padding: "1rem",
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;
  return <>{value === index && <Box sx={{ p: "20px 0px" }}>{children}</Box>}</>;
}

const CustomerDetails: FC = () => {
  const { setPaymentFormModal } = useCommonContext();
  const { TableContainer } = Containers();
  const { PlusIcon1, DownloadIcon } = muiIcons;

  const [value, setValue] = useState(0);
  const tabHandler = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Breadcrumb
        name="Customers"
        subName="Customer Details"
        path="/dashboard/v1"
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <CardContainer sx={{ pb: "2rem" }}>
            <Box mb=".8rem">
              <Box m="1.5rem">
                <Avatar
                  alt="profile"
                  src="/assets/images/faces/1.jpg"
                  sx={{
                    m: "auto",
                    width: 100,
                    height: 100,
                  }}
                />
              </Box>
              <Box textAlign="center" my="1rem">
                <H3>Smith Doe</H3>
                <H4 color="#9e9e9e">Software Engineer</H4>
              </Box>
              <Box display="flex" justifyContent="center">
                {counterBoxData.map((data, index) => (
                  <CounterBox index={index}>
                    <H4>
                      {data.count}
                      <data.Icon />
                    </H4>
                    <H5>{data.name}</H5>
                  </CounterBox>
                ))}
              </Box>
            </Box>

            <ProfileAccordion />
          </CardContainer>
        </Grid>
        <Grid item xs={12} md={8}>
          <Box sx={{ p: 0 }}>
            <Tabs value={value} onChange={tabHandler}>
              <StyledTab label="Overview" />
              <StyledTab label="Events" />
              <StyledTab label="Statements" />
            </Tabs>

            <TabPanel value={value} index={0}>
              <TableContainer>
                <CardHeader>
                  <H3>Payment History</H3>
                  <GullButton
                    variant="contained"
                    color="primary"
                    onClick={() => setPaymentFormModal(true)}
                  >
                    <PlusIcon1 sx={{ fontSize: 15, mr: "10px" }} />
                    Add
                  </GullButton>
                </CardHeader>

                <BasicSortedTable />
                <PaymentFormModal />
              </TableContainer>

              <TableContainer sx={{ mt: "25px" }}>
                <CardHeader>
                  <H3>Payment Methods</H3>
                  <GullButton
                    variant="contained"
                    color="primary"
                    onClick={() => setPaymentFormModal(true)}
                  >
                    <PlusIcon1 sx={{ fontSize: 15, mr: "10px" }} />
                    Add New Method
                  </GullButton>
                </CardHeader>

                <PaymentMethods />
                <PaymentMethodModal />
              </TableContainer>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <TableContainer>
                <CardHeader>
                  <H3>Event History</H3>
                  <GullButton variant="contained" color="primary">
                    <DownloadIcon sx={{ fontSize: 15, mr: "10px" }} />
                    Download Report
                  </GullButton>
                </CardHeader>
                <EventTable />
              </TableContainer>
            </TabPanel>

            <TabPanel value={value} index={2}>
              <StatementCard />

              <TableContainer sx={{ p: 0, mt: "25px" }}>
                <EventTableHeader>
                  <H3>Event History Table</H3>
                  <GullButton variant="contained" color="primary">
                    <DownloadIcon sx={{ fontSize: 15, mr: "10px" }} />
                    Download Report
                  </GullButton>
                </EventTableHeader>
                <StatementTable />
              </TableContainer>
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CustomerDetails;
